import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import moment from 'moment'
import "../../styles.css";
import { Spinner } from "react-bootstrap";

const columnHeaders = [
    { label: "PU username", name: "pu.login", width: '10%'},
    { label: "PU email", name: "pu.email", width: '10%'},
    { label: "PU Commission %", name: "pu.creator.pu_commission_rate", width: '3%'},
    { label: "RU username", name: "ru.login", width: '10%'},
    { label: "RU email", name: "ru.email", width: '10%'},
    { label: "%", name: "percent", width: '4%', align: 'center'},
    // { label: "On", name: "status", width: '3%', align: 'center'},
    { label: "Last Update", name: "date_time", width: '10%'},
    { label: "RU2 username", name: "ru2.login", width: '10%'},
    { label: "RU2 email", name: "ru2.email", width: '10%'},
    { label: "%", name: "percent2", width: '5%', align: 'center'},
    // { label: "On", name: "status2", width: '3%', align: 'center'},
    { label: "Last Update", name: "date_toime2", width: '13%'},
];

const ReferralsTable = (props) => {
    const {
        referrals,
        pageItems,
        page,
        isLoading,
        total,
        orderBy,
        setPage,
        setOrderBy,
        handleActionTable,
        setTableAction,
        tableAction,
        setSearchTrigger,
        searchTrigger
    } = props;

    const handleNextPage = () => {
        if (referrals.current_page < referrals.last_page)
            setPage(referrals.current_page + 1);
            setSearchTrigger(searchTrigger => searchTrigger+1)
    };

    const handleLastPage = () => {
        setPage(referrals.last_page);
        setSearchTrigger(searchTrigger => searchTrigger+1)
    };

    const handlePrevPage = () => {
        if (referrals.current_page > 1)
            setPage(referrals.current_page - 1);
            setSearchTrigger(searchTrigger => searchTrigger+1)
    };

    const handleFirstPage = () => {
        setPage(1);
        setSearchTrigger(searchTrigger => searchTrigger+1)
    };

    const PaginationContainer = () => {
        const isPrevDisabled = page > 1 ? false : true;
        const isNextDisabled = page < referrals.last_page ? false : true;
        return (
            <Pagination
                style={{ justifyContent: "flex-end", alignItems: "center" }}
            >
                <span className="mr-3">
                    {total} item{total > 1 ? "s" : ""}
                </span>
                {/* <Pagination.First
                    disabled={isPrevDisabled}
                    className="mr-1"
                    onClick={handleFirstPage}
                /> */}
                <Pagination.Prev
                    disabled={isPrevDisabled}
                    onClick={handlePrevPage}
                />
                <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
                    <div className="mr-1" style={{ width: 35 }}>
                        <input
                            type="text"
                            className="pagination-input"
                            onChange={(e) => {
                                    setSearchTrigger(searchTrigger => searchTrigger+1);
                                    setPage(e.target.value);
                                }
                            }
                            value={page}
                        />
                    </div>
                    of {pageItems}
                </div>
                <Pagination.Next
                    disabled={isNextDisabled}
                    onClick={handleNextPage}
                />
                {/* <Pagination.Last
                    disabled={isNextDisabled}
                    className="ml-1"
                    onClick={handleLastPage}
                /> */}
            </Pagination>
        );
    };

    const ColumnContainer = () => {
        return (
            <tr>
                {/* {tableAction === 'edit' && ( */}
                    <th
                        className="border-top-0"
                        style={{ width: '2%', textAlign: 'left' }}>
                        &nbsp;
                    </th>
                {/* // )} */}

                {columnHeaders.map((header, index) => {
                    return (
                        <th
                            className="border-top-0"
                            style={{ width: header.width, textAlign: header.align}}
                            key={index}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOrderBy(header.name, orderBy.order);
                                    setSearchTrigger(searchTrigger=>searchTrigger+1)
                                }}>
                                <span style={{ color: "black" }}>
                                    {header.label}
                                    {orderBy.header === header.name && (
                                        <FontAwesomeIcon
                                            className="ml-2"
                                            color="#0097FE"
                                            icon={[
                                                "fas",
                                                orderBy.order === "DESC"
                                                    ? "chevron-down"
                                                    : "chevron-up",
                                            ]}/>
                                    )}
                                </span>
                                
                            </a>
                        </th>
                    );
                })}
            </tr>
        );
    };

    const handleOrderBy = (header, order) => {
        order = order === "ASC" || orderBy.header != header ? "DESC" : "ASC";

        setOrderBy({
            ...orderBy,
            header: header,
            order: order,
        });
    };

    return (
        <div className="w-100">
            <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="d-flex flex-row align-items-center justify-content-between w-100">
                    <div className="w-100 mb-3">
                        <Button
                            variant="primary"
                            className="mr-2"
                            style={{minWidth: '10%'}}
                            disabled={isLoading}
                            onClick={() => handleActionTable('add')}>
                            Add
                        </Button>

                        {/* <Button
                            variant={tableAction === 'edit' ? 'danger' : 'primary'}
                            className="mr-2"
                            style={{minWidth: '10%'}}
                            disabled={isLoading}
                            onClick={() => {
                                if(tableAction === 'edit')
                                    return setTableAction(null);

                                setTableAction('edit')
                            }}>
                            {tableAction === 'edit' && 'Cancel '}
                            Edit
                        </Button> */}
                    </div>


                    {referrals.total > 0 && (
                        <div className="text-right my-2 w-100">
                            {PaginationContainer()}
                        </div>
                    )}
                </div>
            </div>
            {isLoading ? <div className="text-sm my-2"><Spinner variant="primary" size="sm" animation="border" /> Fetching data... </div> : ''}
            {referrals.total > 0 && (
            <>
                <div className="pu-table-container">
                    <Table size="sm" striped hover responsive className="mb-0">
                        <thead>
                            <ColumnContainer />
                        </thead>

                        <tbody>
                            {referrals.data.map((referral, index) => {
                                return (
                                    <tr key={index} className="user-table-row">
                                        {/* {tableAction === 'edit' && ( */}
                                        <td className="text-primary">
                                            <span
                                                className="select-referral"
                                                onClick={() => handleActionTable('edit', referral)}>
                                                Edit
                                            </span>
                                        </td>
                                        {/* )} */}
                                        
                                        <td className="text-secondary">
                                            {referral.pu?.login || ''}
                                        </td>
                                        <td className="text-secondary">
                                            {referral.pu?.email || ''}
                                        </td>
                                        <td className="text-secondary">
                                            {referral.pu?.creator ? referral.pu.creator.pu_commissionrate : ''}
                                        </td>
                                        <td className="text-secondary">
                                            {referral.ru1?.login || ''}
                                        </td>
                                        <td className="text-secondary">
                                            {referral.ru1?.email || ''}
                                        </td>
                                        <td className="text-secondary text-center">
                                            {referral.percent}
                                        </td>
                                        {/* <td className="text-secondary text-center">
                                            {referral.status}
                                        </td> */}
                                        <td className="text-secondary">
                                            {referral.date_time ? moment(referral.date_time).format("YYYY-MM-DD HH:mm") : ''}
                                        </td>
                                        <td className="text-secondary">
                                            {referral.ru2?.login || ''}
                                        </td>
                                        <td className="text-secondary">
                                            {referral.ru2?.email || ''}
                                        </td>
                                        <td className="text-secondary text-center">
                                            {referral.percent2}
                                        </td>
                                        {/* <td className="text-secondary text-center">
                                            {referral.status2}
                                        </td> */}
                                        <td className="text-secondary">
                                            {referral.date_time2 ? moment(referral.date_time2).format("YYYY-MM-DD HH:mm") : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>

                        <tfoot>
                            <ColumnContainer />
                        </tfoot>
                    </Table>
                </div>
                <div className="text-right my-3">
                    {PaginationContainer()}
                </div>
            </>
            )}
        </div>
    );
};

export default ReferralsTable;
